<!-- Filter -->
<div class="table-header-controls">
  @if (isFilterable) {
    <mat-form-field appearance="outline">
      <mat-label>Filter</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="filter" />
    </mat-form-field>
  }

  <!-- Control panel -->
  @if (isControlPanel) {
    <div class="control-panel">
      @for (control of controlList; track control.action) {
        <button
          type="button"
          mat-stroked-button
          [attr.color]="control.color"
          [attr.aria-label]="control.aria"
          [matTooltip]="control.tooltip"
          (click)="processToolbarCommand(control.action)"
        >
          <mat-icon>{{ control?.icon }}</mat-icon>
          @if (control?.text) {
            <span> {{ control?.text }}</span>
          }
        </button>
      }
    </div>
  }
</div>

<!-- Table -->
<div class="table-responsive">
  <table
    class="mat-elevation-z8"
    mat-table
    [dataSource]="tableDataSource"
    matSort
    (matSortChange)="sortTable($event)"
    summary="table preview for chunk results calculation"
  >
    <!-- action column -->
    @if (rowActionIcon?.length) {
      <ng-container [matColumnDef]="rowActionIcon!">
        <th mat-header-cell *matHeaderCellDef></th>
        <td
          mat-cell
          *matCellDef="let element"
          [id]="rowActionIcon"
          (click)="emitRowAction(element)"
        >
          <button mat-button>
            <mat-icon>{{ rowActionIcon }}</mat-icon>
          </button>
        </td>
      </ng-container>
    }

    @for (tableColumn of tableColumns; track tableColumn.dataKey) {
      <ng-container [matColumnDef]="tableColumn.dataKey">
        <!-- if sortable column header -->
        @if (tableColumn.isSortable) {
          <th
            mat-header-cell
            *matHeaderCellDef
            [mat-sort-header]="tableColumn.dataKey"
            [arrowPosition]="
              tableColumn.position === 'right' ? 'before' : 'after'
            "
          >
            {{ tableColumn.name }}
          </th>
        } @else {
          <th
            mat-header-cell
            *matHeaderCellDef
            [class.text-right]="tableColumn.position === 'right'"
          >
            {{ tableColumn.name }}
          </th>
        }
        <!-- else not sortable -->
        <!-- column data -->
        <td
          mat-cell
          *matCellDef="let element"
          [class.text-right]="tableColumn.position === 'right'"
          (click)="emitRowClickAction(element)"
        >
          @if (isImageUrlOrBase64(element[tableColumn.dataKey])) {
            <img
              [src]="element[tableColumn.dataKey]"
              alt="Image"
              width="50"
              height="50"
            />
            <!-- adjust width and height as per your requirement -->
          } @else {
            {{ element[tableColumn.dataKey] }}
          }
        </td>
      </ng-container>
    }

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>

<!-- Pagination -->
@if (isPageable) {
  <mat-paginator
    [pageSizeOptions]="paginationSizes"
    [pageSize]="pageSize"
    showFirstLastButtons
    (page)="onPageChange($event)"
  >
  </mat-paginator>
}
